<template>
    <div>
        <div class="summary-detail-container">
            <server-icon class="summary-detail-container__icon"> </server-icon>
            <div class="summary-detail-container__title">
                My rented servers
            </div>
            <div v-if="!getLoading" class="summary-detail-container__frame">
                <div class="servers-data">
                    <div class="servers-data__rented">Servers Rented</div>
                    <div class="servers-data__rented-number">
                        {{ getServers.totalServers }}
                    </div>
                    <div class="servers-data__active">Servers Active</div>
                    <div class="servers-data__active-number">
                        {{ getServers.activeServers }}
                    </div>
                    <div class="servers-data__workload">
                        <strong>Workload (Server)</strong>
                    </div>
                    <div class="servers-data__workload-number">
                        <strong v-if="getWorkloadServer > 0"
                            >{{ Math.round(getWorkloadServer) }}%</strong
                        >
                        <strong v-else>0</strong>
                    </div>
                    <div class="servers-data__workload-idle-number">
                        <strong v-if="getWorkloadPeak > 0"
                            >{{ Math.round(getWorkloadPeak) }}%</strong
                        >
                        <strong v-else>0</strong>
                    </div>
                    <div class="servers-data__current-players">
                        Current Players
                    </div>
                    <div class="servers-data__current-players-number">
                        {{ getCurrentPlayers }}
                    </div>
                    <div class="servers-data__peak-players">
                        Peak Players
                    </div>
                    <div class="servers-data__peak-players-number">
                        {{ getPeakPlayers }}
                    </div>
                </div>
            </div>
            <loading-detail
                v-else
                class="summary-detail-container__frame"
            ></loading-detail>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateFormat } from '@/lib/dateFormat';
import ServerIcon from 'Svgs/server.svg?inline';
import LoadingDetail from '@/components/common/loading/LoadingDetail';

export default {
    name: 'SummaryDetail',
    components: { ServerIcon, LoadingDetail },
    computed: {
        ...mapGetters('module_servers', {
            getServers: 'getServers',
            getCurrentPlayers: 'getCurrentPlayers',
            getPeakPlayers: 'getPeakPlayers',
            getMaxPlayers: 'getMaxPlayers',
            getWorkloadServer: 'getWorkloadServer',
            getWorkloadPeak: 'getWorkloadPeak',
            getLoading: 'getLoading',
        }),
    },
    methods: {
        dateFormat,
    },
};
</script>

<style scoped lang="scss">
.summary-detail-container {
    display: grid;
    grid-template-columns: 1fr 20fr;
    grid-template-rows: 3rem 14rem;
    &__frame {
        grid-column: 1 / 5;
        grid-row: 2;
        height: 337px;
        width: 90%;
        border-radius: 6px;
        border: 1px solid $blue-main;
        margin: 1rem auto auto 3rem;

        @media (max-width: $xl-up) {
            width: 90%;
            height: 446px;
        }
        @media (min-width: $sm-up) and (max-width: $lg-up) {
            width: 90%;
            // height: 480px;
        }
        @media (min-width: $xs-up) and (max-width: $sm-up) {
            height: 380px;
            width: 90%;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 90%;
            height: $small-height;
            margin: 1rem auto auto 1.5rem;
        }
    }
    &__icon {
        margin: 1.3rem auto auto 3rem;
        width: 30px;
        @media (max-width: $xl-up) {
            margin: 1.2rem auto auto 3rem;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            margin: 1.2rem auto auto 1.5rem;
        }
    }
    &__title {
        margin: 4px auto auto 0.5rem;
        width: 261px;
        height: 29px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 0.44px;
        line-height: 53px;
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 250px;
        }
    }
}
.servers-data {
    display: grid;
    grid-template-columns: 2fr 1fr 6fr;
    grid-template-rows: repeat(4, 1fr);
    margin: 2rem auto auto 2rem;
    color: $blue-main;
    font-family: $istok-font;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0.2px;
    line-height: 30px;
    @media (max-width: $sm-up) {
        grid-template-columns: 3fr 1.5fr 2fr;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-template-rows: repeat(4, 3rem);
        margin: 1rem auto auto 2rem;
    }

    &__rented {
        grid-column: 1;
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 1 / 2;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: 1;
            grid-column: 1 / 4;
            font-weight: 700;
        }
    }
    &__rented-number {
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-row: 1;
            grid-column: 2 / 3;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: 2;
            grid-column: 1 / 4;
            margin: 0 0.7rem;
        }
    }
    &__active {
        grid-column: 1;
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 1 / 2;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            font-weight: 700;
            grid-row: 3;
            grid-column: 1 / 4;
        }
    }
    &__active-number {
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 2 / 3;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 1 / 2;
            grid-row: 4;
            margin: 0 0.7rem;
        }
    }
    &__workload {
        grid-column: 1;
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 1 / 2;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-row: 5;
            grid-column: 1 / 4;
        }
    }
    &__workload-number {
        margin: $servers-margin;
        color: #19b767;
        @media (max-width: $sm-up) {
            grid-column: 2 / 3;
            grid-row: 3;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: auto;
            grid-row: 6;
            margin: 0 0.7rem 1rem 0.7rem;
        }
    }
    &__workload-idle-number {
        margin: $servers-margin;
        color: #f8451d;
        @media (max-width: $sm-up) {
            grid-column: 3 / 4;
            grid-row: 3;
            margin-left: 0;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 2 / 4;
            grid-row: 6;
            width: 70px;
            margin: 0 0.7rem 1rem 0.7rem;
        }
    }
    &__current-players {
        grid-column: 1;
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 1 / 2;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            font-weight: 700;
            grid-row: 7;
            grid-column: 1 / 4;
        }
    }
    &__current-players-number {
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 2 / 3;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 1 / 3;
            grid-row: 8;
            margin: 0 0.7rem 1rem 0.7rem;
        }
    }
    &__peak-players {
        grid-column: 1;
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 1 / 2;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            font-weight: 700;
            grid-row: 9;
            grid-column: 1 / 3;
        }
    }
    &__peak-players-number {
        margin: $servers-margin;
        @media (max-width: $sm-up) {
            grid-column: 2 / 3;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            grid-column: 1 / 3;
            grid-row: 10;
            margin: 0 0.7rem 1rem 0.7rem;
        }
    }
}
</style>
